<template>
  <section>
    <el-dialog
        :close-on-click-modal="false"
        title="修改出车打款金额"
        :lock-scroll="true"
        :visible.sync="dialogFormVisible"
        width="500px"
    >
      <section v-loading="getDetailLoading">
        <qx-custom-form @sub="sub" :noSubBtn="true" ref="customForm" :formData="formData" labelWidth="150px">
          <section slot="detail" class="detailBox">
            <div v-for="(item,index) in originData.orderMoneyTypeList" :key="index">
              <el-form-item :label="item.moneyTypeName">
                <el-input
                    style="width: 240px"
                    class="inputBox small-input-box"
                    v-model="item.moneyTypeValueDouble"
                    placeholder="输入金额"
                    @blur=setCarPrepayMoney
                    onkeyup="value=value.replace(/[^\d\.]/g,'').replace(/^0(\d+)$/,'$1')"
                >
                </el-input>
              </el-form-item>

            </div>
          </section>
        </qx-custom-form>
      </section>
      <section slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button
              type="primary"
              @click="customFormPost"
              :loading="subLoading || getDetailLoading"
          >确 定</el-button
          >
      </section>
    </el-dialog>
  </section>

</template>

<script>
import {updateOrderMoneyTypeList} from 'api/operate';

export default {
  data () {
    return {
      prePayInfo: {},
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      merLoading: false, // 商户选项loading中
      originData: {},
      buttonData: [],
      formData: {
        form: [
          {
            label: '出车打款金额',
            value: 'carPrepayMoney',
            type: 'input',
            disabled: true,
            allcustom: true,
          },
          {
            label: '',
            value: 'detail',
            slot: true,
          },
        ],
        rules: {
        },
      },
    };
  },
  methods: {

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      this.$nextTick(() => {
        this.$refs.customForm && this.$refs.customForm.reset();
        this.originData = JSON.parse(JSON.stringify(item));
        item.carPrepayMoney = item.carPrepayMoneyDouble;
        this.$refs.customForm.setVal(item);
      });
    },

    setCarPrepayMoney (e) {
      let total = 0;
      this.originData.orderMoneyTypeList.map((item) => {
        total += Number(item.moneyTypeValueDouble);
      });
      this.$refs.customForm.setVal('carPrepayMoney', total.toFixed(2));
    },

    customFormPost () {
      this.$refs.customForm.sub();
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      this.subLoading = true;
      let carPrepayMoneyDetail = this.originData.orderMoneyTypeList.map((item) => ({
        id: String(item.id),
        moneyTypeValue: String(item.moneyTypeValueDouble),
      }));
      const res = await updateOrderMoneyTypeList({
        carPrepayMoneyUpdateList: JSON.stringify([...carPrepayMoneyDetail]),
        carPrepayMoney: form.carPrepayMoney,
      });
      this.subLoading = false;
      if (!res.failed) {
        this.dialogFormVisible = false; // 关闭弹窗
        this.$message({
          type: 'success',
          message: '保存成功',
        });
        this.$emit('sub');
      }

    },
  },
};
</script>

<style lang="scss" scoped>

.detailBox{
  position: relative;
  top: 0;
  left: -175px;
  padding-left: 24px
}

</style>
